module.exports = __webpack_public_path__ + "img/logo.2845d376.png";